import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import {
  BoxButtons,
  Box,
  BoxFields,
  CancelButton,
  PrimaryButton,
  StyledLabel,
  Title,
  WrapperTotal,
} from "./styles";

import { IConfiguration } from "../../../../../@types/configuration.type";

interface ModalFormJiraProps {
  configurations: IConfiguration[];
  open: boolean;
  handleClose: () => void;
  handleSave: (token: string, email: string, url: string) => void;
}


export const ModalFormJira = ({
  configurations,
  open,
  handleClose,
  handleSave
}: ModalFormJiraProps) => {

  const [token, setToken] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [url, setUrl] = useState<string>("");

  useEffect(() => {
    const jiraConfigurationToken = configurations.find(x => x.key === "CONFIGURATION_JIRA_API_TOKEN")
    const jiraConfigurationEmail = configurations.find(x => x.key === "CONFIGURATION_JIRA_EMAIL")
    const jiraConfigurationUrl = configurations.find(x => x.key === "CONFIGURATION_JIRA_URL")
    setToken(jiraConfigurationToken?.value ?? "");
    setEmail(jiraConfigurationEmail?.value ?? "");
    setUrl(jiraConfigurationUrl?.value ?? "");
  }, [open]);



  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <WrapperTotal>
          <button title="Fechar" onClick={() => handleClose()}>
            X
          </button>
          <Title>Conectar com o Jira</Title>
          <Box>
            <StyledLabel>Token da API do Jira</StyledLabel>
            <BoxFields>
              <TextField
                id="outlined-required"
                label="Token"
                value={token}
                onChange={(e) => {
                  setToken(e.target.value);
              }}
              />
            </BoxFields>
          </Box>
          <Box>
            <StyledLabel>E-mail do Jira</StyledLabel>
            <BoxFields>
              <TextField
                id="outlined-required"
                label="E-mail"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
              }}
              />
            </BoxFields>
          </Box>

          <Box>
            <StyledLabel>Url do Jira</StyledLabel>
            <BoxFields>
              <TextField
                id="outlined-required"
                label="E-mail"
                value={url}
                onChange={(e) => {
                  setUrl(e.target.value);
              }}
              />
            </BoxFields>
          </Box>

          <BoxButtons>
            <CancelButton onClick={() => handleClose()} type="button">
              Cancelar
            </CancelButton>
            <PrimaryButton onClick={() => handleSave(token, email, url)}>Salvar</PrimaryButton>
          </BoxButtons>
        </WrapperTotal>
      </Modal>
    </>
  );
};
